/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from "@reduxjs/toolkit";
import { signInAction } from "../actions/signIn.action";
import { GenericApiAttributes } from "types/interfaces/api";
import { signUpAction } from "../actions/signup.action";
import { initialStateInterface } from "../interfaces/interface";


const initialState: initialStateInterface = {
  isLoading: false,
  error: null,
  isError: false,
  user:null,
  isSuccess: false
} 

const SignUpSlice = createSlice({
  name: "signUpSlice",

  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(signUpAction.fulfilled, (state, action) => {
        state.user = action.payload;
        state.error = null;
        state.isSuccess = true;
        state.isError = false;
      })

      .addCase(signUpAction.pending, (state) => {
        state.isLoading = true;
      })

      .addCase(signUpAction.rejected, (state, action) => {
        state.user = null;
        state.error = action.error.message;
        state.isError = true;
      })
  },
});

export default SignUpSlice.reducer;
